var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-3 vx-row"},[_c('div',{staticClass:"w-full vx-col mb-base"},[_c('Table',{attrs:{"draw":_vm.draw,"status":_vm.activeTab,"source-warehouse-id":(this.selectedSrcWarehouse) ? this.selectedSrcWarehouse.id : 0}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }